import { takeEvery } from 'redux-saga/effects';

import * as signInActions from 'store/modules/auth/signIn';
import { facebookSignIn } from './utils';

export default function* listenFacebookSignIn() {
  yield takeEvery(signInActions.facebookSignIn.toString(), facebookSignIn);
}
